import { FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslation } from '../../../../../commons/useTranslasion';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper2: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslation();
  const { novoUsuario } = props;
  const methods = useFormContext();

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h5" component="h2">
            {translate('referencia')}
          </Typography>
        </Grid>
        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate('referenciaP1')}
          </Typography>
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <Controller
            control={methods.control}
            name='referencia'
            render={({ field: { ref, ...field } }) => (
              <TextField
                sx={{ width: "100%" }}
                id="standard-multiline-static"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="outlined"
                disabled
                multiline
                rows={8}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

      </Grid>
    </>
  );
};

export default PPCStepper2;
